export default {"src":"/_next/static/media/mobile-bilan.924747d6.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};